import { render, staticRenderFns } from "./BrandChanges.vue?vue&type=template&id=e01056ae&scoped=true"
import script from "./BrandChanges.vue?vue&type=script&lang=js"
export * from "./BrandChanges.vue?vue&type=script&lang=js"
import style0 from "./BrandChanges.vue?vue&type=style&index=0&id=e01056ae&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01056ae",
  null
  
)

export default component.exports